type FormattedValueProps = {
    value: number | null;
    unit: string;
    isLoaded: boolean;
    isSmall?: boolean;
}

export const FormattedValue: React.FC<FormattedValueProps> = ({ value, unit, isLoaded, isSmall = false }: FormattedValueProps) => {
    return (
        <span className={isSmall ? 'is-size-7' : ''}>
            {(!isLoaded || value === null) ?
                <span className="loading-shimmer"></span>
                :
                `${value.toFixed(value % 1 === 0 ? 0 : 1)} ${unit}`
            }
        </span>
    );
};
